/**
 * SGKE361A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ShishinInputTab {

    /**
     * 供給停止年月日
     */
    supplystopYearmonthdate?: string;
    /**
     * 供給停止時刻
     */
    supplystopHms?: string;
    /**
     * 停止時指針
     */
    duringstopShishin?: number;
    /**
     * 停止時使用量
     */
    duringstopEmpamt?: number;
    /**
     * マイコンメーター点滅フラグ
     */
    microcontrollermeterFlashingFlg?: string;
    /**
     * メーター休止フラグ
     */
    meterPauseFlg?: string;
    /**
     * 供給停止時メーターガス栓閉止フラグ
     */
    supplysuspensiontimeMetergassenFlg?: string;
    /**
     * 閉止不能理由コード
     */
    shutoffFunoRsncod?: string;
    /**
     * 供給停止時処置フラグ
     */
    supplysuspensiontimeTreatmentFlg?: string;
    /**
     * エフ取付フラグ
     */
    efuInstallationFlg?: string;
    /**
     * 供給停止書投函場所コード
     */
    supplystopdocumentPostingLocationcode?: string;
    /**
     * 供給再開種別
     */
    supplyresumptionClsfy?: string;
    /**
     * 変更前供給停止予定日付
     */
    bfSupplystopScddt?: string;
    /**
     * 変更後供給停止予定日付
     */
    afSupplystopScddt?: string;
    /**
     * 供給停止作業担当ユーザID
     */
    supplystopWorkchargeUserid?: string;
    /**
     * 供給停止作業担当者名
     */
    supplystopWorkTantoshaname?: string;
    /**
     * 前回メーター番号
     */
    preMeterNo?: string;
    /**
     * 前回メーター型式
     */
    preMeterModel?: string;
    /**
     * 前回メーター能力
     */
    preMeterAbility?: number;
    /**
     * メーター情報一致フラグ
     */
    meterInfoIcchiflag?: string;
    /**
     * メーター取替有無フラグ
     */
    meterTorikaeEonflg?: string;
    /**
     * 取外メーター番号
     */
    removalMeterNo?: string;
    /**
     * 取外時指針
     */
    duringremovalShishin?: number;
    /**
     * 取付メーター番号
     */
    installationMeterNo?: string;
    /**
     * 取付時指針
     */
    duringinstallationShishin?: number;
    /**
     * メーター回転有無フラグ
     */
    meterRotationEonflg?: string;
    /**
     * 再開時指針
     */
    onresumptionShishin?: number;
    /**
     * 再開時メーター番号
     */
    onresumptionMeterNo?: string;
}

